import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { CheckboxInput } from 'components/core';

const NotificationSettings = ({ onCheckboxClick, checkEmailNotification, checkTextNotification }) => {
  const { t } = useTranslation();

  return (
    <CheckboxContainer>
      <CheckboxInput
        onClick={onCheckboxClick}
        checked={checkTextNotification}
        option={{
          label: t('account.receive-text-updates', 'Receive order status updates via text message'),
          name: `textNotifications`,
          key: 'text-updates',
        }}
      />
      <CheckboxInput
        onClick={onCheckboxClick}
        checked={checkEmailNotification}
        option={{
          label: t('account.receive-email-updates', 'Receive important email updates about dutchie'),
          name: `emailNotifications`,
          key: 'email-updates',
        }}
      />
    </CheckboxContainer>
  );
};

export default NotificationSettings;

const CheckboxContainer = styled.div`
  margin-top: 21px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;
